import {
  Component,
  ChangeDetectionStrategy,
  input,
  output
} from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

import { Step } from '../models/step.model';

@Component({
  selector: 'app-wizard-progress',
  templateUrl: './wizard-progress.component.html',
  styleUrls: ['./wizard-progress.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslatePipe]
})
export class WizardProgressComponent {
  readonly steps = input<Step[]>(undefined);
  readonly currentStepNumber = input<number>(undefined);
  readonly selectStep = output<Step>();

  public onSelectStep(step: Step) {
    return this.selectStep.emit(step);
  }
}
